import React from 'react'

class JobProtectedLeaveSummary extends React.Component{
  render() {
    return(
      <div className="job-protected-leave-summary">
        { this.props.benefits.job_protected_benefits.length > 0 && <span className='job-protected-benefit'/> }
      </div>
    );
  }
}

export default JobProtectedLeaveSummary
